export default function () {
  return {
    receivedPhoneNumber: undefined,
    sendDate: undefined,
    hasSuccessfullyCreatedAccount: undefined,
    customerNumber: undefined,
  };
}
